import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  divisorLine: (theme, { vertical }) => css`
    background-color: ${theme.colors.neutral[100]};
    height: ${vertical ? '100%' : '1px'};
    width: ${vertical ? '1px' : 'initial'};
    margin: ${vertical ? `0 ${theme.spacing.md}` : `${theme.spacing.xs} 0`};
  `,
})

export default useStyles
